export interface IComparisonVolume {
    centerId: number,
    centerAlias: string,
    year: number,
    thisMonth: number,
    lastMonth: number,
    monthsAgo2: number,
    monthsAgo3: number,
    monthsAgo4: number,
    monthsAgo5: number,
    monthsAgo6: number,
    monthsAgo7: number,
    monthsAgo8: number,
    monthsAgo9: number,
    monthsAgo10: number,
    monthsAgo11: number,
    total: number
}
